import React from 'react';
import classNames from 'classnames';
import Portal from 'src/components/layouts/Portal/Portal';
import styles from './ContainerOverlay.module.scss';

export interface ContainerOverlayProps {
  children: React.ReactNode;
  isExpanded: boolean;
  className?: string;
}

const ContainerOverlay = React.forwardRef<HTMLDivElement, ContainerOverlayProps>(
  ({ children, isExpanded, className }, ref) => {
    return (
      <Portal isFullView backdrop>
        <div ref={ref} className={classNames(styles.root, className, { [styles.open]: isExpanded })}>
          {children}
        </div>
      </Portal>
    );
  },
);

export default ContainerOverlay;
